export enum IWikiType {
  main = 0,
  sub = 1,
}

export enum GeoGSONTypes {
  Point = "Point",
  MultiPoint = "MultiPoint",
  LineString = "LineString",
  MultiLineString = "MultiLineString",
  Polygon = "Polygon",
  MultiPolygon = "MultiPolygon",
  GeometryCollection = "GeometryCollection",
}
